import styled, {css} from 'styled-components';

interface ItemProps {
  checked?: boolean;

  readonly color?: string;
  readonly size?: string;
  readonly margin?: string;  
}

export const WraperLegend = styled.div`
  height: 53px;
  display: flex;
  border-radius: 8px;
  align-items: center;
  background-color: #EBEDF2;
  justify-content: space-around;
`;

export const ButtonLegend = styled.button<ItemProps>`  
  border: none;
  height: 47px;
  display: flex;
  padding: 15px;
  margin-right: 7px;
  border-radius: 8px;
  align-items: center;
  flex-direction: row;    
  background-color: ${props => (props.checked ? '#FFF' : '#EBEDF2')};
  box-shadow: ${props => (props.checked ? '0 1px 1px 0 rgba(0,0,0,0.17)' : '0')};      
  &:first-child {
    margin-left: 3px;
  }
  &:last-child {
    margin-right: 3px;
  }
  &:hover {
    cursor: pointer;
  }
`;

export const ButtonSpan = styled.span`
  color: #5D6E81;
  font-size: 14px;
  line-height: 13px;
  letter-spacing: -0.17px;
  font-family: "Proxima Nova";
`;

export const OvalLegend = styled.div<ItemProps>`
  margin-left: auto;
  display: inline-block;
  border-radius: 50% 50% 50% 50%;
  ${props => {    
    const margin = 'margin:' + props.margin + ';';
    const background = 'background:' + props.color + ';';
    const width = 'min-width:' + props.size + 'px;width:' + props.size + 'px;';
    const height = 'min-height:' + props.size + 'px;height:' + props.size + 'px;';
    
    return css`{
      ${width}
      ${margin}
      ${height}
      ${background}
    }`;
  }};
`;